// extracted by mini-css-extract-plugin
export var externalLink = "_b3-0";
export var internalLinkLabel = "_b3-1";